import { render, staticRenderFns } from "./moodul_muuda_info.vue?vue&type=template&id=8ccbc2ae&scoped=true&"
import script from "./moodul_muuda_info.vue?vue&type=script&lang=js&"
export * from "./moodul_muuda_info.vue?vue&type=script&lang=js&"
import style0 from "./moodul_muuda_info.vue?vue&type=style&index=0&id=8ccbc2ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ccbc2ae",
  null
  
)

export default component.exports